import * as React from "react";
import { Component } from "react";
import { Form } from "react-bootstrap";
import ServiceCharges from "../ServiceCharges";
import StatementSummary from "../StatementSummary";
import ElectricityCredited from "./ElectricityCredited";
import ElectricityFromGrid from "./ElectricityFromGrid";
import { IAdvancedDualRateStatementProps, IAdvancedDualRateStatementState } from "./interfaces";
import NetElectricity from "./NetElectricity";
import SolarGenerated from "./SolarGenerated";

export default class AdvancedDualRateStatement extends Component<
  IAdvancedDualRateStatementProps,
  IAdvancedDualRateStatementState
> {
  public constructor(props: IAdvancedDualRateStatementProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public render() {
    const totalGridUsage = this.props.gridReading - this.props.priorGridReading;
    const onPeakGridUsage = this.props.onPeakGridReading - this.props.priorOnPeakGridReading;
    const offPeakGridUsage = totalGridUsage - onPeakGridUsage;

    const totalSolarReceived = this.props.solarReading - this.props.priorSolarReading;
    const onPeakSolarCredited = this.props.onPeakSolarReading - this.props.priorOnPeakSolarReading;
    const offPeakSolarCredited = totalSolarReceived - onPeakSolarCredited;

    return (
      <div className="flex">
        <div className="left-column">
          <Form horizontal={true}>
            <StatementSummary
              appService={this.props.appService}
              match={this.props.match}
              serviceStartDate={this.props.serviceStartDate}
              serviceEndDate={this.props.serviceEndDate}
              serviceStartDateChanged={this.props.serviceStartDateChanged}
              serviceEndDateChanged={this.props.serviceEndDateChanged}
              statementDate={this.props.statementDate}
              yearsWithSolar={this.props.yearsWithSolar}
              totalAmountDue={this.props.totalAmountDue}
              statementDateChanged={this.props.statementDateChanged}
              yearsWithSolarChanged={this.props.yearsWithSolarChanged}
              totalAmountDueChanged={this.props.totalAmountDueChanged}
              showNetElectricityCredit={this.props.showNetElectricityCredit}
              netElectricityCredit={this.props.netElectricityCredit}
              netElectricityCreditChanged={this.props.netElectricityCreditChanged}
            />
            <ElectricityFromGrid
              appService={this.props.appService}
              history={this.props.history}
              match={this.props.match}
              gridReadDate={this.props.gridReadDate}
              gridReading={this.props.gridReading}
              priorGridReadDate={this.props.priorGridReadDate}
              priorGridReading={this.props.priorGridReading}
              onPeakGridReadDate={this.props.onPeakGridReadDate}
              onPeakGridReading={this.props.onPeakGridReading}
              priorOnPeakGridReadDate={this.props.priorOnPeakGridReadDate}
              priorOnPeakGridReading={this.props.priorOnPeakGridReading}
              gridReadDateChanged={this.props.gridReadDateChanged}
              gridReadingChanged={this.props.gridReadingChanged}
              priorGridReadDateChanged={this.props.priorGridReadDateChanged}
              priorGridReadingChanged={this.props.priorGridReadingChanged}
              onPeakGridReadDateChanged={this.props.onPeakGridReadDateChanged}
              onPeakGridReadingChanged={this.props.onPeakGridReadingChanged}
              priorOnPeakGridReadDateChanged={this.props.priorOnPeakGridReadDateChanged}
              priorOnPeakGridReadingChanged={this.props.priorOnPeakGridReadingChanged}
              priorDataEditable={this.props.priorDataEditable}
            />
            <ElectricityCredited
              appService={this.props.appService}
              history={this.props.history}
              match={this.props.match}
              solarReadDate={this.props.solarReadDate}
              solarReading={this.props.solarReading}
              priorSolarReadDate={this.props.priorSolarReadDate}
              priorSolarReading={this.props.priorSolarReading}
              onPeakSolarReadDate={this.props.onPeakSolarReadDate}
              onPeakSolarReading={this.props.onPeakSolarReading}
              priorOnPeakSolarReadDate={this.props.priorOnPeakSolarReadDate}
              priorOnPeakSolarReading={this.props.priorOnPeakSolarReading}
              solarReadDateChanged={this.props.solarReadingDateChanged}
              solarReadingChanged={this.props.solarReadingChanged}
              priorSolarReadDateChanged={this.props.priorSolarReadingDateChanged}
              priorSolarReadingChanged={this.props.priorSolarReadingChanged}
              onPeakSolarReadDateChanged={this.props.onPeakSolarReadDateChanged}
              onPeakSolarReadingChanged={this.props.onPeakSolarReadingChanged}
              priorOnPeakSolarReadDateChanged={this.props.priorOnPeakSolarReadDateChanged}
              priorOnPeakSolarReadingChanged={this.props.priorOnPeakSolarReadingChanged}
              priorDataEditable={this.props.priorDataEditable}
            />
          </Form>
        </div>
        <div className="right-column">
          <Form horizontal={true}>
            <SolarGenerated
              appService={this.props.appService}
              match={this.props.match}
              history={this.props.history}
              solarGenerated={this.props.solarGenerated}
              solarGeneratedChanged={this.props.solarGeneratedChanged}
              solarReading={this.props.solarReading}
              priorSolarReading={this.props.priorSolarReading}
              onPeakSolarReading={this.props.onPeakSolarReading}
              priorOnPeakSolarReading={this.props.priorOnPeakSolarReading}
              priorDataEditable={this.props.priorDataEditable}
            />
            <NetElectricity
              appService={this.props.appService}
              match={this.props.match}
              totalElectricityFromGrid={this.props.gridReading - this.props.priorGridReading}
              onPeakGridUsage={onPeakGridUsage}
              onPeakSolarCredited={onPeakSolarCredited}
              onPeakSolarCredits={this.props.onPeakCredits}
              offPeakGridUsage={offPeakGridUsage}
              offPeakSolarCredited={offPeakSolarCredited}
              offPeakSolarCredits={this.props.offPeakCredits}
              onPeakSolarCreditsChanged={this.props.onPeakCreditsChanged}
              offPeakSolarCreditsChanged={this.props.offPeakCreditsChanged}
              priorDataEditable={this.props.priorDataEditable}
            />
          </Form>
        </div>
        <div>
          <ServiceCharges
            title="Service Charges"
            match={this.props.match}
            needsSaving={this.props.needsSaving}
            serviceCharges={this.props.serviceCharges}
            addServiceCharge={this.props.addServiceCharge}
            deleteServiceCharge={this.props.deleteServiceCharge}
            updateServiceCharge={this.props.updateServiceCharge}
            copyPriorServiceCharges={this.props.copyPriorServiceCharges}
          />
          <ServiceCharges
            title="Taxes and Fees"
            match={this.props.match}
            needsSaving={this.props.needsSaving}
            serviceCharges={this.props.taxesAndFees}
            addServiceCharge={this.props.addTaxAndFee}
            deleteServiceCharge={this.props.deleteTaxAndFee}
            updateServiceCharge={this.props.updateTaxAndFee}
            copyPriorServiceCharges={this.props.copyPriorTaxesAndFees}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/dualrate/AdvancedDualRateStatement.tsx